(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["snap-archives"]) return;
  try {
    
(function(){
  var tl=document.getElementById('arcTimeline'); if(!tl) return;
  var entries=[].slice.call(tl.querySelectorAll('.arc-entry'));
  if(matchMedia('(prefers-reduced-motion: reduce)').matches){ entries.forEach(function(e){ e.classList.add('in'); }); return; }
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  },{threshold:0.2,rootMargin:'0px 0px -8% 0px'});
  entries.forEach(function(e){ io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snap-cart"]) return;
  try {
    
(function(){
  var page=document.getElementById('cartPage'); if(!page) return;
  var routes=(window.HANG&&window.HANG.routes)||{change:'/cart/change.js',cart:'/cart.js'};
  function money(c){
    var f=(window.HANG&&window.HANG.moneyFormat)||'${{amount}}';
    var v=(c/100).toFixed(2).replace(/\.00$/,'');
    return f.replace(/\{\{\s*amount\s*\}\}/,v).replace(/\{\{\s*amount_no_decimals\s*\}\}/,Math.round(c/100));
  }
  function setCart(c){
    if(window.hangSetCart) window.hangSetCart(c.item_count);
    var hc=document.getElementById('cartHdrCount'); if(hc) hc.textContent=c.item_count;
    var sub=document.getElementById('cartSubtotal'); if(sub) sub.textContent=money(c.total_price);
    if(c.item_count===0){ location.reload(); return; }
  }
  function change(key,qty,row){
    if(row) row.classList.add('removing');
    fetch(routes.change,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(c){
        if(qty===0){ if(row) row.parentNode.removeChild(row); setCart(c); return; }
        var li=c.items.filter(function(i){return i.key===key;})[0];
        if(row){ row.classList.remove('removing');
          if(li){ row.querySelector('.qty-n').textContent=li.quantity; row.querySelector('.citem-line').textContent=money(li.final_line_price); } }
        setCart(c);
      }).catch(function(){ if(row) row.classList.remove('removing'); });
  }
  page.addEventListener('click',function(e){
    var row=e.target.closest('.citem'); if(!row) return;
    var key=row.dataset.key, n=parseInt(row.querySelector('.qty-n').textContent,10)||1;
    if(e.target.closest('.qty-up')) change(key,n+1,row);
    else if(e.target.closest('.qty-dn')) change(key,Math.max(0,n-1),row);
    else if(e.target.closest('.citem-remove')) change(key,0,row);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snap-collection-story"]) return;
  try {
    
(function(){
  var grid=document.getElementById('csGrid');
  if(grid){
    var tiles=[].slice.call(grid.querySelectorAll('.tile'));
    var rank={available:0,low:1,preorder:2,comingsoon:3,soldout:4,archive:5};
    tiles.map(function(t,i){ return {t:t,r:(rank[t.dataset.s]==null?4:rank[t.dataset.s]),i:i}; })
      .sort(function(a,b){ return a.r-b.r || a.i-b.i; })
      .forEach(function(o){ grid.appendChild(o.t); });
  }
  var box=document.querySelector('.cs-about[data-collapsible]');
  if(box){
    var short=box.querySelector('.cd-short'), full=box.querySelector('.cd-full'), btn=box.querySelector('.cd-toggle'), open=false;
    btn.addEventListener('click',function(){ open=!open; short.hidden=open; full.hidden=!open; btn.textContent=open?'Read less −':'Read more +'; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snap-collection"]) return;
  try {
    
(function(){
  var grid=document.getElementById('cGrid'); if(!grid) return;
  var tiles=[].slice.call(grid.querySelectorAll('.tile'));
  var cc=document.getElementById('cCount');
  if(cc){ var n=grid.querySelectorAll('.tile:not(.tile-coming)').length; cc.textContent=(n<10?'0':'')+n+(n===1?' piece':' pieces'); }
  /* same ordering as Shop: in-stock first, newest-first within each group */
  var rank={available:0,low:1,preorder:2,comingsoon:3,soldout:4,archive:5};
  tiles.map(function(t,i){ return {t:t,r:(rank[t.dataset.s]==null?4:rank[t.dataset.s]),i:i}; })
    .sort(function(a,b){ return a.r-b.r || a.i-b.i; })
    .forEach(function(o){ grid.appendChild(o.t); });
})();
/* collection write-up: expand / collapse (hero grows so the full text isn't clipped) */
(function(){
  var box=document.querySelector('.chero-desc[data-collapsible]'); if(!box) return;
  var hero=document.querySelector('.chero');
  var short=box.querySelector('.cd-short'), full=box.querySelector('.cd-full'), btn=box.querySelector('.cd-toggle');
  var open=false;
  btn.addEventListener('click',function(){
    open=!open;
    short.hidden=open; full.hidden=!open;
    btn.textContent=open?'Read less −':'Read more +';
    if(hero) hero.classList.toggle('expanded',open);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snap-collections"]) return;
  try {
    
(function(){
  var g=document.getElementById('colsGrid'), c=document.getElementById('colsCount');
  if(!g||!c) return;
  var n=g.querySelectorAll('.ccard').length;
  c.textContent=n+' collection'+(n===1?'':'s');
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snap-email-popup"]) return;
  try {
    
(function(){
  var el=document.getElementById('hangPromo'); if(!el) return;
  var editor = (window.Shopify && Shopify.designMode);
  /* ?promo in the URL forces it open + ignores the cooldown — handy for local testing */
  var force = editor || /[?&]promo(=|&|$)/.test(location.search);
  var KEY=el.getAttribute('data-key')||'hang_promo_v1';
  var days=parseInt(el.getAttribute('data-days'),10)||14;
  function state(){ try{ return JSON.parse(localStorage.getItem(KEY)||'{}'); }catch(e){ return {}; } }
  function mark(extra){ try{ var s=state(); Object.assign(s,extra); localStorage.setItem(KEY,JSON.stringify(s)); }catch(e){} }
  if(!force){
    var st=state();
    if(st.done) return;
    if(st.seen && (Date.now()-st.seen) < days*864e5) return;
  }
  var shown=false, timer;
  function show(){
    if(shown) return; shown=true;
    clearTimeout(timer); window.removeEventListener('scroll',onScroll);
    el.hidden=false;
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ el.classList.add('open'); }); });
    if(!force) mark({seen:Date.now()});
  }
  function close(){ el.classList.remove('open'); setTimeout(function(){ el.hidden=true; },420); if(!force) mark({seen:Date.now()}); }
  function onScroll(){ if((window.pageYOffset||document.documentElement.scrollTop||0) > 480) show(); }
  var delay = force ? 600 : (parseInt(el.getAttribute('data-delay'),10)||15)*1000;
  timer=setTimeout(show, delay);
  if(el.getAttribute('data-scroll')==='1') window.addEventListener('scroll',onScroll,{passive:true});
  el.addEventListener('click',function(e){ if(e.target.closest('[data-promo-close]')) close(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !el.hidden) close(); });

  /* sale mode: tap the code chip to copy it */
  var codeBtn=document.getElementById('promoCode');
  if(codeBtn){
    codeBtn.addEventListener('click',function(){
      var code=codeBtn.getAttribute('data-code')||'', hint=document.getElementById('promoCodeHint');
      function ok(){ if(hint){ hint.textContent='Copied ✓'; setTimeout(function(){ hint.textContent='Tap to copy'; },1800); } }
      if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(code).then(ok).catch(ok); }
      else { ok(); }
    });
  }

  /* email mode: capture into Klaviyo */
  var form=document.getElementById('promoForm');
  if(form){
    var input=document.getElementById('promoEmail'), send=document.getElementById('promoSend'), done=document.getElementById('promoDone');
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var email=(input.value||'').trim();
      if(!email || email.indexOf('@')<1){ input.focus(); return; }
      send.textContent='…'; send.disabled=true; input.disabled=true;
      subscribe(email).then(function(){
        mark({done:true});
        form.style.display='none';
        var fine=el.querySelector('.promo-fine'); if(fine) fine.style.display='none';
        if(done) done.hidden=false;
      }).catch(function(){ send.textContent='Try again'; send.disabled=false; input.disabled=false; });
    });
  }
  function subscribe(email){
    var company=window.HANG_KLAVIYO_COMPANY_ID, rev=window.HANG_KLAVIYO_REVISION||'2024-10-15',
        list=el.getAttribute('data-list'), src=el.getAttribute('data-source')||'Homepage 10% Popup';
    if(!company || !list){ return Promise.resolve(); } /* not configured yet — still confirm to the visitor */
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(company),{
      method:'POST', headers:{'Content-Type':'application/json','revision':rev},
      body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:src,profile:{data:{type:'profile',attributes:{email:email}}}},relationships:{list:{data:{type:'list',id:list}}}}})
    }).then(function(r){ if(!r.ok && r.status!==202){ throw new Error('sub failed'); } });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snap-header"]) return;
  try {
    
(function(){
  var openBtn=document.getElementById('hdrSearch'), panel=document.getElementById('srch');
  if(!openBtn||!panel) return;
  var input=document.getElementById('srchInput'), closeBtn=document.getElementById('srchClose'),
      results=document.getElementById('srchResults'), recentWrap=document.getElementById('srchRecentWrap'), recent=document.getElementById('srchRecent');
  var KEY='hang_recent_searches', t;
  function getRecent(){ try{ return JSON.parse(localStorage.getItem(KEY))||[]; }catch(e){ return []; } }
  function saveRecent(q){ q=(q||'').trim(); if(!q) return; var r=getRecent().filter(function(x){ return x.toLowerCase()!==q.toLowerCase(); }); r.unshift(q); localStorage.setItem(KEY, JSON.stringify(r.slice(0,6))); }
  function esc(s){ return (s||'').replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function renderRecent(){ var r=getRecent(); if(!r.length){ recentWrap.hidden=true; return; } recentWrap.hidden=false; recent.innerHTML=r.map(function(q){ return '<button type="button" class="srch-chip" data-q="'+esc(q)+'">'+esc(q)+'</button>'; }).join(''); }
  var closeT;
  function openPanel(){ clearTimeout(closeT); panel.hidden=false; document.documentElement.style.overflow='hidden'; renderRecent(); requestAnimationFrame(function(){ requestAnimationFrame(function(){ panel.classList.add('open'); }); }); setTimeout(function(){ input.focus(); },120); }
  function closePanel(){ panel.classList.remove('open'); document.documentElement.style.overflow=''; closeT=setTimeout(function(){ panel.hidden=true; },320); }
  openBtn.addEventListener('click',openPanel);
  closeBtn.addEventListener('click',closePanel);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!panel.hidden) closePanel(); });
  function run(q){
    q=(q||'').trim();
    if(q.length<2){ results.innerHTML=''; return; }
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var items=(d.resources&&d.resources.results&&d.resources.results.products)||[];
        if(!items.length){ results.innerHTML='<div class="srch-none">No matches — try another term</div>'; return; }
        results.innerHTML=items.map(function(p){
          var src=p.featured_image&&p.featured_image.url;
          var img=src?('<img src="'+src+'" alt="" loading="lazy">'):'<span class="srch-noimg"></span>';
          return '<a class="srch-hit" href="'+p.url+'">'+img+'<span class="srch-hit-t">'+esc(p.title)+'</span></a>';
        }).join('');
      }).catch(function(){});
  }
  input.addEventListener('input',function(){ clearTimeout(t); var q=input.value; if(q.trim().length<2){ results.innerHTML=''; return; } t=setTimeout(function(){ run(q); },220); });
  function go(q){ q=(q||'').trim(); if(!q) return; saveRecent(q); location.href='/search?q='+encodeURIComponent(q)+'&type=product'; }
  input.addEventListener('keydown',function(e){ if(e.key==='Enter') go(input.value); });
  panel.addEventListener('click',function(e){
    var chip=e.target.closest('.srch-chip');
    if(chip){ go(chip.dataset.q); return; }
    if(e.target.closest('.srch-hit')) saveRecent(input.value);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snap-home"] && !Shopify.designMode) return;
  try {
    
/* Announcement banner scrolls away (not sticky) — slide the fixed nav up in lockstep so there's no gap */
(function(){
  var bar=document.querySelector('.snap-cd'); if(!bar) return;
  var hdr=document.querySelector('.hdr'); if(!hdr) return;
  var raf;
  /* the homepage scrolls INSIDE #snap (body is overflow:hidden), not the window */
  var scroller=document.getElementById('snap');
  function apply(){
    raf=null;
    var y=(scroller?scroller.scrollTop:0)||window.pageYOffset||document.documentElement.scrollTop||0;
    hdr.style.top=Math.max(0, bar.offsetHeight - y)+'px';
  }
  function onScroll(){ if(!raf) raf=requestAnimationFrame(apply); }
  apply();
  (scroller||window).addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll, {passive:true});
})();
/* Headline reveal — play the word-rise + ™ stamp the moment the loader clears (fallbacks for editor/no-loader) */
(function(){
  var hl=document.querySelector('.hl'); if(!hl) return;
  var col=document.querySelector('.hero-collage');
  var played=false;
  function play(){ if(played) return; played=true; hl.classList.add('play'); if(col) col.classList.add('drop'); }
  if(document.getElementById('loader')){
    window.addEventListener('hang:loaderdone', play, {once:true});
    setTimeout(play, 7000); /* safety: never leave the headline hidden */
  } else {
    requestAnimationFrame(function(){ setTimeout(play, 120); });
  }
})();
/* Shuffle the hero photo wall on every load so every curated photo gets a shot at the top (runs while it's still invisible, before the fade-in) */
(function(){
  var col=document.querySelector('.hero-collage'); if(!col) return;
  var kids=[].slice.call(col.children);
  for(var i=kids.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)), t=kids[i]; kids[i]=kids[j]; kids[j]=t; }
  kids.forEach(function(k,idx){ col.appendChild(k); k.style.setProperty('--delay',(idx*0.035 + Math.random()*0.03).toFixed(3)+'s'); });
})();
/* Hero collage parallax — the photo wall sits further back and scrolls slower than the headline/Tailz (desktop only) */
(function(){
  if(!matchMedia('(min-width:1000px)').matches) return;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var col=document.querySelector('.hero-collage'), hero=col&&col.closest('.hero');
  if(!col||!hero) return;
  var sc=document.getElementById('snap')||window, raf, FACTOR=0.4;
  function update(){
    raf=null;
    var t=-hero.getBoundingClientRect().top; if(t<0) t=0;
    col.style.transform='translate3d(0,'+(t*FACTOR).toFixed(1)+'px,0)';
  }
  function onScroll(){ if(!raf) raf=requestAnimationFrame(update); }
  sc.addEventListener('scroll', onScroll, {passive:true});
  addEventListener('resize', onScroll, {passive:true});
  update();
})();
/* Background + nav colour — scroll-interpolated between sections, so the bg, the nav bar, and the
   logo colour all blend smoothly (no flicker) and the nav goes light/dark to stay legible. */
(function(){
  var bg=document.getElementById('snapBg'), scroller=document.getElementById('snap'), hdr=document.querySelector('.hdr');
  if(!bg||!scroller) return;
  var secs=[].slice.call(document.querySelectorAll('[data-bg]'));
  if(!secs.length) return;
  /* nav colour for each section bg (complementary palette); falls back to field cream */
  var NAV={'#518BC9':'#FFAD1C','#FFAD1C':'#518BC9','#07273B':'#8F0017','#8F0017':'#E3DED6','#E3DDD6':'#E3DDD6','#004A3D':'#8F0017'};
  function rgb(h){ h=h.replace('#',''); return [parseInt(h.substr(0,2),16),parseInt(h.substr(2,2),16),parseInt(h.substr(4,2),16)]; }
  function mix(a,b,t){ var x=rgb(a),y=rgb(b); return 'rgb('+Math.round(x[0]+(y[0]-x[0])*t)+','+Math.round(x[1]+(y[1]-x[1])*t)+','+Math.round(x[2]+(y[2]-x[2])*t)+')'; }
  function navOf(s){ return s.getAttribute('data-nav') || NAV[(s.getAttribute('data-bg')||'').toUpperCase()] || '#E3DED6'; }
  function lum(h){ var c=rgb(h); return (0.299*c[0]+0.587*c[1]+0.114*c[2])/255; }
  var raf;
  function update(){
    raf=null;
    var vh=window.innerHeight, bi=0;
    for(var k=0;k<secs.length;k++){ if(secs[k].getBoundingClientRect().top<=1) bi=k; }
    var base=secs[bi], next=secs[bi+1]||base;
    var prog=vh?Math.min(1,Math.max(0,-base.getBoundingClientRect().top/vh)):0;
    bg.style.backgroundColor=mix(base.getAttribute('data-bg'), next.getAttribute('data-bg'), prog);
    if(hdr){
      hdr.style.setProperty('--nav-bg', mix(navOf(base), navOf(next), prog));
      var domNav=prog<0.5?navOf(base):navOf(next);
      hdr.style.setProperty('--nav-fg', lum(domNav)>0.6?'#07273B':'#EDEFE5');
    }
  }
  function onScroll(){ if(!raf) raf=requestAnimationFrame(update); }
  scroller.addEventListener('scroll', onScroll, {passive:true});
  addEventListener('resize', onScroll, {passive:true});
  update();
})();

/* Collection grids — taped photos pop into place as each section enters view */
(function(){
  var secs=[].slice.call(document.querySelectorAll('.csec'));
  if(!secs.length) return;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches){ secs.forEach(function(s){ s.classList.add('in'); }); return; }
  var sc=document.getElementById('snap');
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  },{root:sc||null, threshold:0.25});
  secs.forEach(function(s){ io.observe(s); });
})();
/* Collection-card titles: same word-rise as the hero, fired once each card has risen to centre.
   Viewport root + a centre-band rootMargin so the text pops AFTER the card settles (works on mobile + desktop). */
(function(){
  var titles=[].slice.call(document.querySelectorAll('.csec-title.hl'));
  if(!titles.length) return;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches){ titles.forEach(function(t){ t.classList.add('play'); }); return; }
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ var el=e.target; setTimeout(function(){ el.classList.add('play'); }, 90); io.unobserve(el); } });
  },{root:null, rootMargin:'-32% 0px -30% 0px', threshold:0.01});
  titles.forEach(function(t){ io.observe(t); });
})();
/* Nice News → Klaviyo client subscriptions (email or SMS). Company id + revision come from snippets/klaviyo-restock.liquid */
window.hangNice=function(e){
  e.preventDefault();
  var f=e.target, b=f.querySelector('button[type=submit]'), inp=document.getElementById('newsInput');
  var modeBtn=f.querySelector('.toggle button.on'); var mode=modeBtn?modeBtn.dataset.mode:'email';
  var val=(inp.value||'').trim(); if(!val){ inp.focus(); return false; }
  var listId=f.dataset.list;
  if(!listId){ b.textContent='List not set'; setTimeout(function(){ b.textContent='Sign up'; },1800); return false; }
  var attrs={};
  if(mode==='sms'){ var d=val.replace(/[^0-9]/g,''); if(d.length===10){ d='1'+d; } attrs.phone_number='+'+d; }
  else { attrs.email=val; }
  b.disabled=true; b.textContent='…';
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(window.HANG_KLAVIYO_COMPANY_ID),{
    method:'POST',
    headers:{'Content-Type':'application/json','revision':window.HANG_KLAVIYO_REVISION},
    body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Nice News',profile:{data:{type:'profile',attributes:attrs}}},relationships:{list:{data:{type:'list',id:listId}}}}})
  }).then(function(r){
    if(r.ok||r.status===202){ b.textContent="You're in ✓"; b.style.background='#07273B'; b.style.color='#fff'; }
    else { b.disabled=false; b.textContent='Try again'; }
  }).catch(function(){ b.disabled=false; b.textContent='Try again'; });
  return false;
};
document.addEventListener('click',function(e){ var t=e.target.closest('.toggle button'); if(!t)return;
  t.parentElement.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===t);});
  var inp=document.getElementById('newsInput'); if(inp){ inp.type=t.dataset.mode==='sms'?'tel':'email'; inp.placeholder=t.dataset.mode==='sms'?'(615) 555-0123':'you@haveanicegame.com'; }
});
/* Tailz — DVD-screensaver bounce inside the hero container */
(function(){
  var head=document.getElementById('tailz'); if(!head)return;
  var hero=head.closest('.hero')||head.parentElement;
  var hdr=document.querySelector('.hdr');
  var x=0,y=0,vx=-1.0,vy=-0.64,W=0,H=0,S=0,PX=0,PY=0,TOP=0;
  /* the PNG has a transparent margin around the mascot (~24% horiz, ~26% vert);
     overshoot the left/right/bottom edges by that margin so the visible head kisses the browser edge,
     but bounce the top off the bottom of the fixed nav bar instead of sliding under it */
  function measure(){
    var r=hero.getBoundingClientRect(); W=r.width; H=r.height;
    S=head.getBoundingClientRect().width||head.offsetWidth; PX=S*0.243; PY=S*0.262;
    TOP = hdr ? hdr.offsetHeight : 0;
    if(TOP > H - S) TOP = Math.max(0, H - S); /* guard: never invert the bounce range */
  }
  /* hero-coloured solid silhouette that rides directly behind the line-art head,
     masking its transparent interior so you never see the navy trails through the line art */
  var backer=null, backerSrc=head.getAttribute('data-backer');
  if(backerSrc){
    backer=head.cloneNode(true);
    backer.removeAttribute('id'); backer.removeAttribute('data-ghost'); backer.removeAttribute('data-backer');
    backer.className='tailz-float tailz-backer';
    backer.src=backerSrc;
    head.parentNode.insertBefore(backer, head);
  }
  function place(){
    var t='translate('+x.toFixed(1)+'px,'+y.toFixed(1)+'px)';
    head.style.transform=t;
    if(backer){ backer.style.transform=t; }
  }
  /* start on the right, ~30% down, then drift up-and-left into the negative space */
  measure(); x=(W-S)*0.66; y=TOP+(H-TOP)*0.30; place();
  if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* trailing rope — the ghosts hang off the head like a windsock:
     verlet physics gives real lag + momentum + whip when it turns, and a travelling
     perpendicular sine wave makes the rope undulate through the air even on a straight line. */
  var TRAIL=6, ghosts=[], rp=[];
  var ghostSrc=head.getAttribute('data-ghost');
  for(var gi=0; gi<TRAIL; gi++){
    var g=head.cloneNode(true);
    g.removeAttribute('id');
    g.removeAttribute('data-ghost');
    g.removeAttribute('data-backer');
    g.className='tailz-float tailz-ghost';
    if(ghostSrc){ g.src=ghostSrc; }
    g.style.opacity=(0.46 * (1 - gi/(TRAIL+1))).toFixed(3);
    g.dataset.sc=(0.97 - gi/(TRAIL-1)*0.18).toFixed(3); /* stay fat — only a slight taper, no pointy tail */
    hero.insertBefore(g, head);
    ghosts.push(g);
  }
  /* seed the rope stretched out behind the head along its initial heading so it doesn't whip out from a point */
  var L0=Math.max(9,S*0.05), isp=Math.sqrt(vx*vx+vy*vy)||1;
  for(var ri=0; ri<=TRAIL; ri++){ var ox=x-(vx/isp)*L0*ri, oy=y-(vy/isp)*L0*ri; rp.push({x:ox,y:oy,px:ox,py:oy}); }
  function loop(){
    if(!W||!H||!S){ measure(); }
    x+=vx; y+=vy;
    if(x<=-PX){ x=-PX; vx=Math.abs(vx); } else if(x+S>=W+PX){ x=W+PX-S; vx=-Math.abs(vx); }
    if(y<=TOP-PY){ y=TOP-PY; vy=Math.abs(vy); } else if(y+S>=H+PY){ y=H+PY-S; vy=-Math.abs(vy); }
    place();
    var L=Math.max(9,S*0.05);
    rp[0].x=x; rp[0].y=y;
    /* verlet: each trailing point carries momentum (friction<1 = it lingers + overshoots on turns) */
    for(var i=1;i<=TRAIL;i++){
      var p=rp[i], nx=(p.x-p.px)*0.9, ny=(p.y-p.py)*0.9;
      p.px=p.x; p.py=p.y; p.x+=nx; p.y+=ny;
    }
    /* relax to a rest length so the rope hangs off (and trails) the head */
    for(var it=0; it<3; it++){
      rp[0].x=x; rp[0].y=y;
      for(var j=1;j<=TRAIL;j++){
        var a=rp[j-1], b=rp[j], dx=b.x-a.x, dy=b.y-a.y, d=Math.sqrt(dx*dx+dy*dy)||0.0001, diff=(d-L)/d;
        b.x-=dx*diff; b.y-=dy*diff;
      }
    }
    /* render each ghost straight on the rope — pure lagging blur trail, no perpendicular wiggle */
    for(var k=0;k<TRAIL;k++){
      var cur=rp[k+1];
      ghosts[k].style.transform='translate('+cur.x.toFixed(1)+'px,'+cur.y.toFixed(1)+'px) scale('+ghosts[k].dataset.sc+')';
    }
    requestAnimationFrame(loop);
  }
  addEventListener('resize',function(){ measure(); if(x+S>W+PX)x=W+PX-S; if(y+S>H+PY)y=H+PY-S; },{passive:true});
  requestAnimationFrame(loop);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snap-nice"] && !Shopify.designMode) return;
  try {
    
(function(){
  var el=document.getElementById('niceLP'); if(!el) return;
  var form=document.getElementById('niceForm'), input=document.getElementById('niceEmail'),
      send=document.getElementById('niceSend'), done=document.getElementById('niceDone');
  var SEND_LABEL=send.textContent;
  /* clear a custom error the moment they start correcting it */
  input.addEventListener('input',function(){ if(input.setCustomValidity) input.setCustomValidity(''); });

  /* Does the email's domain actually accept mail? Ask public DNS-over-HTTPS for MX
     (fall back to A) records. On a network/DNS hiccup we DON'T block a real person. */
  function domainAcceptsMail(domain){
    var base='https://dns.google/resolve?name='+encodeURIComponent(domain);
    return fetch(base+'&type=MX').then(function(r){ return r.json(); }).then(function(d){
      if(d.Status===3){ return false; } /* NXDOMAIN — the domain doesn't exist */
      if(d.Answer && d.Answer.some(function(a){ return a.type===15; })){ return true; } /* has MX */
      return fetch(base+'&type=A').then(function(r){ return r.json(); }).then(function(a){
        return !!(a.Answer && a.Answer.length); /* some domains take mail on the A record */
      });
    }).catch(function(){ return true; });
  }

  form.addEventListener('submit',function(e){
    e.preventDefault();
    var email=(input.value||'').trim();
    /* 1) real format check + the browser's native email validity (type="email") */
    var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) && (input.checkValidity ? input.checkValidity() : true);
    if(!ok){ if(input.reportValidity){ input.reportValidity(); } input.focus(); return; }
    send.textContent='…'; send.disabled=true; input.disabled=true;
    /* 2) does the domain actually exist / accept mail? */
    domainAcceptsMail(email.split('@')[1]||'').then(function(valid){
      if(!valid){
        input.disabled=false; send.disabled=false; send.textContent=SEND_LABEL;
        if(input.setCustomValidity){ input.setCustomValidity("We can't find that email domain. Double-check the spelling."); }
        if(input.reportValidity){ input.reportValidity(); }
        input.focus();
        return;
      }
      return subscribe(email).then(function(){
        form.style.display='none';
        var fine=el.querySelector('.np-fine'); if(fine) fine.style.display='none';
        if(done) done.hidden=false;
      });
    }).catch(function(){ send.textContent='Try again'; send.disabled=false; input.disabled=false; });
  });
  function subscribe(email){
    var company=window.HANG_KLAVIYO_COMPANY_ID, rev=window.HANG_KLAVIYO_REVISION||'2024-10-15',
        list=el.getAttribute('data-list'), src=el.getAttribute('data-source')||'Nice News Landing';
    if(!company || !list){ return Promise.resolve(); } /* not configured — still confirm to the visitor */
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(company),{
      method:'POST', headers:{'Content-Type':'application/json','revision':rev},
      body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:src,profile:{data:{type:'profile',attributes:{email:email}}}},relationships:{list:{data:{type:'list',id:list}}}}})
    }).then(function(r){ if(!r.ok && r.status!==202){ throw new Error('sub failed'); } });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snap-search"]) return;
  try {
    
(function(){
  var bar=document.getElementById('searchFilters'), grid=document.getElementById('searchGrid');
  if(!bar||!grid) return;
  var tiles=[].slice.call(grid.querySelectorAll('.tile'));
  var empty=document.getElementById('searchEmpty'), count=document.getElementById('searchCount');
  var fCat=null, showArch=false;
  function apply(){
    var shown=0;
    tiles.forEach(function(t){
      var ok = (showArch || t.dataset.s !== 'archive') && (!fCat || t.dataset.c===fCat);
      t.classList.toggle('hide',!ok); if(ok) shown++;
    });
    if(empty) empty.hidden = shown>0;
    if(count) count.textContent = shown + (shown===1?' result':' results');
  }
  bar.addEventListener('click',function(e){
    var b=e.target.closest('.ef'); if(!b||b.classList.contains('ef-clear')) return;
    fCat = b.dataset.c || null;
    bar.querySelectorAll('.ef').forEach(function(x){ x.classList.toggle('on', x===b); });
    apply();
  });
  var archBtn=document.getElementById('searchArch');
  if(archBtn){ archBtn.addEventListener('click',function(){
    showArch=!showArch; archBtn.classList.toggle('on',showArch); archBtn.setAttribute('aria-pressed',showArch?'true':'false'); apply();
  }); }
  /* in-stock first, then pre-order, coming-soon, sold-out, archive — newest-first within each group */
  var rank={available:0,low:1,preorder:2,comingsoon:3,soldout:4,archive:5};
  tiles.map(function(t,i){ return {t:t,r:(rank[t.dataset.s]==null?4:rank[t.dataset.s]),i:i}; })
    .sort(function(a,b){ return a.r-b.r||a.i-b.i; })
    .forEach(function(o){ grid.appendChild(o.t); });
  apply();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snap-shop"]) return;
  try {
    
(function(){
  var bar=document.getElementById('shopFilters'), grid=document.getElementById('shopGrid');
  if(!bar||!grid) return;
  var tiles=[].slice.call(grid.querySelectorAll('.tile'));
  var empty=document.getElementById('shopEmpty'), count=document.getElementById('shopCount');
  var fCat=null, showArch=false;
  function apply(){
    var shown=0;
    tiles.forEach(function(t){
      var ok = (showArch || t.dataset.s !== 'archive') && (!fCat || t.dataset.c===fCat);
      t.classList.toggle('hide',!ok); if(ok && !t.classList.contains('tile-coming')) shown++;
    });
    if(empty) empty.hidden = shown>0;
    if(count) count.textContent = shown + (shown===1?' item':' items');
  }
  bar.addEventListener('click',function(e){
    var b=e.target.closest('.ef'); if(!b) return;
    fCat = b.dataset.c || null;
    bar.querySelectorAll('.ef').forEach(function(x){ x.classList.toggle('on', x===b); });
    apply();
  });
  var archBtn=document.getElementById('shopArch');
  var archFlash=document.getElementById('archFlash'), archFlashT;
  function archFlashShow(){
    if(!archFlash) return;
    clearTimeout(archFlashT); archFlash.hidden=false;
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ archFlash.classList.add('show'); }); });
    archFlashT=setTimeout(archFlashHide, 2600);
  }
  function archFlashHide(){ if(!archFlash) return; clearTimeout(archFlashT); archFlash.classList.remove('show'); setTimeout(function(){ archFlash.hidden=true; }, 380); }
  if(archFlash){ archFlash.addEventListener('click', archFlashHide); }
  if(archBtn){ archBtn.addEventListener('click',function(){
    showArch=!showArch; archBtn.classList.toggle('on',showArch); archBtn.setAttribute('aria-pressed',showArch?'true':'false'); apply();
    if(showArch){ archFlashShow(); } else { archFlashHide(); }
  }); }

  /* default order: coming-soon first, then in-stock, pre-order, sold-out (archive excluded from Shop) — newest-first preserved within each group */
  var rank={comingsoon:0,available:1,low:2,preorder:3,soldout:4,archive:5};
  tiles.map(function(t,i){ return {t:t,r:(rank[t.dataset.s]==null?4:rank[t.dataset.s]),i:i}; })
    .sort(function(a,b){ return a.r-b.r || a.i-b.i; })
    .forEach(function(o){ grid.appendChild(o.t); });
  apply(); /* default: all (by type), archive hidden */
  /* restock/notify modal is global (snippets/snap-restock-modal.liquid) — buttons here just carry data-mode */
})();

  } catch(e) { console.error(e); }
})();
})();
